<div class="mui-card">
  <div class="mui-card__content">
    <img src="/frontend-container/assets/img/unexpected-error.svg" class="mb-5" alt="Unexpected Error" />
    <h2 class="text-center">{{ 'global.error.request.navigation.title' | translate }}</h2>
    <p>{{ 'global.error.request.navigation.message' | translate }}</p>
  </div>
  <div class="mui-card__footer text-center">
    <button *ngIf="showReload; else homeBtn" mui-btn (click)="reload()" icon="refresh">
      {{ 'global.error.request.navigation.reloadBtn' | translate }}
    </button>
  </div>
</div>

<ng-template #homeBtn>
  <a mui-btn routerLink="/" icon="arrow-right">
    {{ 'global.error.request.navigation.homeBtn' | translate }}
  </a>
</ng-template>
